/* eslint-disable @direct-frontend/modules/slice-boundaries -- характеристики нужны для отображения маппинга */
import { useMemo } from 'react';
import { useCharacteristicsGetAll } from '#entities/characteristic';
import { type OpenApiGetIntegrationMappingSettingsPathParameters } from '#shared/api/schema';
import { useGetIntegrationMappingSettings } from '../../../api';
import { mapMappingToTags } from '../lib/mapMappingToTags';

export const useIntegrationMappingDisplayLabels = ({
    integration_type,
}: OpenApiGetIntegrationMappingSettingsPathParameters): string => {
    const { data: mapping } = useGetIntegrationMappingSettings({ integration_type });
    const { data: characteristics } = useCharacteristicsGetAll({});

    return useMemo(
        () =>
            mapMappingToTags(mapping, characteristics ?? [])
                .map(({ tag }) => tag)
                .join(', '),
        [characteristics, mapping]
    );
};
